<template>
  <div class="v2-social-buttons" :class="{ 'icons-only': iconsOnly }">
    <a
      v-for="item in socials"
      :key="item.icon"
      target="_blank"
      :href="item.url"
      rel="nofollow"
      :aria-label="`Follow us in ${item.icon}`"
      @click="sendTrack(item.url)"
    >
      <i :class="`icon icon-${item.icon}`" />
    </a>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { amplitudeTrack } from "@/utils/amplitude";

defineOptions({
  name: "social-buttons",
});

defineProps({
  iconsOnly: {
    type: Boolean,
    default: false,
  },
});

const socials = ref([
  {
    url: "https://www.tiktok.com/@erstiesofficial",
    icon: "tiktok",
  },
  {
    url: "https://twitter.com/erstiesmodels",
    icon: "twitter",
  },
]);

const sendTrack = (url: string) => {
  amplitudeTrack("Social icon click", { url });
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
